import { useConnection } from '@solana/wallet-adapter-react'
import { StakeProgram } from '@solana/web3.js'
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'

const SolPriceContext = createContext<SolPriceContextValue | null>(null)

type SolPriceContextValue = {
  minimumRent: number
}

export const SolPriceProvider = ({ children }: PropsWithChildren) => {
  const { connection } = useConnection()
  const [minimumRent, setMinimumRent] = useState<number>(0)

  useEffect(() => {
    const fetchMinimumRent = async () => {
      try {
        const minimumRent = await connection.getMinimumBalanceForRentExemption(StakeProgram.space)
        setMinimumRent(minimumRent)
      } catch (error) {
        console.error('Failed to fetch minimum rent:', error)
      }
    }

    if (connection) {
      fetchMinimumRent()
    }
  }, [connection])

  return <SolPriceContext.Provider value={{ minimumRent }}>{children}</SolPriceContext.Provider>
}

export const useSolPrice = (): SolPriceContextValue => {
  const context = useContext(SolPriceContext)
  if (context === null) {
    throw new Error('useSolPriceContext must be used within SolPriceProvider')
  }
  return context
}
